import MjChip from "../components/ui/MjChip";

export const chipSelector = (chip) => {
  return <MjChip name={chip} />;
};
